import {
  getZrmListingInfo,
  getZrmRentalsLead,
  getZrmUserInfo,
  type ZrmClickstreamLead,
  type ZrmClickstreamListing,
} from '@zg-rentals/clickstream';
import { trackListingEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_TYPE } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

const OTHER_ACTIONS_MENU = 'other_actions_menu';
const LEAD_PROFILE_CARD = 'lead_profile_card';

// https://dataportal.zillowgroup.net/event-registry/5131
export const CLICK_OTHER_ACTIONS_MENU_EVENT_TYPE_ID = '5131';
export const emitClickOtherActionsMenuEvent = (
  user: ZrmClickstreamUserOrNull,
  listing: ZrmClickstreamListing,
  lead?: ZrmClickstreamLead | null,
) =>
  trackListingEvent({
    envelope: {
      event_type_id: CLICK_OTHER_ACTIONS_MENU_EVENT_TYPE_ID,
      event_type_version_id: '3',
      event_template_id: '628',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.LeadManagementPage,
      trigger_source_nm: OTHER_ACTIONS_MENU,
      trigger_object_nm: 'open_menu',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });

export type OtherActionsTriggerObject = typeof OTHER_ACTIONS_MENU | typeof LEAD_PROFILE_CARD;

// https://dataportal.zillowgroup.net/event-registry/5132
export const emitClickOptionsFromOtherActionsMenuEvent = ({
  user,
  listing,
  triggerSourceName,
  triggerObjectName = OTHER_ACTIONS_MENU,
  lead,
}: {
  user: ZrmClickstreamUserOrNull;
  listing: ZrmClickstreamListing;
  triggerSourceName: string;
  triggerObjectName?: OtherActionsTriggerObject;
  lead?: ZrmClickstreamLead | null;
}) =>
  trackListingEvent({
    envelope: {
      event_type_id: '5132',
      event_type_version_id: '8',
      event_template_id: '628',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.LeadManagementPage,
      trigger_source_nm: triggerSourceName,
      trigger_object_nm: triggerObjectName,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ManageLead,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });
